import type { StateType } from '../../lib/types/state-type';

export function setContent(state: StateType, parameters: unknown[]): StateType {
  const content = parameters[0] as string;
  // Home gehoert furnhome selbst. Jedes andere Modul oeffnet nur, wer das Recht dazu hat - bisher
  // schuetzte nur die fehlende Rail-Kachel, ein Link wuerde daran vorbeifuehren.
  const isAllowed = content === 'home' || state.allowedModules.includes(content);
  return { ...state, content: isAllowed ? content : 'home' };
}
